import { SharePanelAction, SharePanelActionKeys } from './actions';
import { Api } from '../../../typings/api';

export enum SharePanelMethod {
	EMAIL = '@@sharePanelMethod/EMAIL',
	FACEBOOK = '@@sharePanelMethod/FACEBOOK',
	TWITTER = '@@sharePanelMethod/TWITTER',
	GOOGLEPLUS = '@@sharePanelMethod/GOOGLEPLUS',
	LINKEDIN = '@@sharePanelMethod/LINKEDIN',
	PINTEREST = '@@sharePanelMethod/PINTEREST',
}

interface EmailFormState {
	name: string;
	userEmail: string;
	contactEmail: string;
	message: string;
}

export interface SharePanelState {
	isOpen: boolean;
	selection: Api.DriveItem[];
	foldersContent: Api.DriveItem[];
	method: SharePanelMethod;
	form: EmailFormState;
}

const initialState: SharePanelState = {
	isOpen: false,
	selection: [],
	foldersContent: [],
	method: SharePanelMethod.EMAIL,
	form: {
		name: '',
		userEmail: '',
		contactEmail: '',
		message: '',
	},
};

export function sharePanel(
	state: SharePanelState = initialState,
	action: SharePanelAction
): SharePanelState {
	switch (action.type) {
		case SharePanelActionKeys.REQUEST_OPEN:
			return {
				...state,
				isOpen: true,
				form: {
					...state.form,
					contactEmail: '',
					message: '',
				}
			};
		case SharePanelActionKeys.REQUEST_CLOSE:
			return { ...state, isOpen: false, foldersContent: [] };
		case SharePanelActionKeys.SET_SELECTION:
			return { ...state, selection: action.selection };
		case SharePanelActionKeys.SET_METHOD:
			return { ...state, method: action.method };
		case SharePanelActionKeys.SET_FORM_FIELD:
			return {
				...state,
				form: {
					...state.form,
					[action.name]: action.value,
				}
			};
		case SharePanelActionKeys.UPDATE_FOLDERS_CONTENT:
			return { ...state, foldersContent: [...state.foldersContent, action.item] };
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/Panel/reducer.ts